'use client';

import React from 'react';
import styled from '@emotion/styled';
import { IUrlLinkItem, Main } from '@/ui';
import { useCommonData } from '../../../../common-data/useCommonData';
import { Footer } from '../../../../components/common/footer/Footer';
import { getFooterLinksFormEntry } from '../../../../utils/getFooterLinksFromEntry';
import { IFooterLinkSections } from '../../../../components/common/footer/types';
import { IFooterSocialLinksProps } from '../../../../components/common/footer/FooterSocialLinks';
import { SilentErrorBoundary } from '../../components/error/SilentErrorBoundary';
import { ErrorBoundary } from '../../components/error/ErrorBoundary';
import { AlertBanners } from '../../../../components/alert-banner/AlertBanners';

export interface IPageLayoutProps {
	children?: React.ReactNode;
	withoutFooter?: boolean;
}

export const PageLayout = ({
	children,
	withoutFooter = false,
}: IPageLayoutProps) => {
	const { footer, pathToPageIdMap, mostRecentNewsAlert } = useCommonData();

	let linkSections;

	if (footer) {
		linkSections = getFooterLinksFormEntry(footer, pathToPageIdMap);
	}

	return (
		<LayoutContentWrap>
			<header>
				{mostRecentNewsAlert && (
					<AlertBanners
						title={mostRecentNewsAlert.fields.title}
						body={mostRecentNewsAlert.fields.body}
						link={mostRecentNewsAlert.fields.link}
					/>
				)}
			</header>
			{/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
			{/* @ts-ignore */}
			<ErrorBoundary>
				<Main>{children}</Main>
			</ErrorBoundary>

			{footer && !withoutFooter && (
				<SilentErrorBoundary>
					<Footer
						linkSections={linkSections?.linkSections as IFooterLinkSections}
						socialLinks={linkSections?.socialLinks as IFooterSocialLinksProps}
						finePrint={linkSections?.finePrintLinks.links as IUrlLinkItem[]}
					/>
				</SilentErrorBoundary>
			)}
		</LayoutContentWrap>
	);
};

export const LayoutContentWrap = styled(Main)`
	margin: 0;
	position: relative;
	overflow-x: hidden;
`;
